// extracted by mini-css-extract-plugin
module.exports = {"subMenuWrapper":"SubMenu_subMenuWrapper__S0skK"};